import { gql } from '@apollo/client';

import { BALANCE_HISTORY_FIELDS, PAGE_INFO_FIELDS } from './fields';

export const GET_BALANCE_HISTORY = gql`
  ${BALANCE_HISTORY_FIELDS}

  ${PAGE_INFO_FIELDS}

  query BalanceHistory(
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    balanceHistory(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        ...balanceHistoryFields
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;
